(() => {
  if (window.__medicalScrubsProductInit) return;
  window.__medicalScrubsProductInit = true;

  const select = (root, selector) => Array.from(root.querySelectorAll(selector));
  const variantsScript = document.querySelector('[data-scrub-variants]');
  let variants = [];

  try {
    variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
  } catch (error) {
    variants = [];
  }

  const updateProductFormVariant = () => {
    const form = document.querySelector('[data-scrub-product-form]');
    const variantInput = form?.querySelector('[data-scrub-variant-id]');
    const addButton = form?.querySelector('[data-scrub-add-to-cart]');
    const addButtonText = form?.querySelector('[data-scrub-add-to-cart-text]');
    if (!form || !variantInput || variants.length === 0) return;

    const selectedOptions = [];
    select(document, '[data-option-position]').forEach((button) => {
      if (!button.classList.contains('is-selected')) return;
      const position = Number(button.dataset.optionPosition || 0);
      if (!position) return;
      selectedOptions[position - 1] = button.dataset.scrubOption || button.textContent.trim();
    });

    const matchedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => {
        return !selectedOptions[index] || selectedOptions[index] === option;
      });
    });

    if (!matchedVariant) return;
    variantInput.value = matchedVariant.id;

    if (addButton) {
      addButton.disabled = !matchedVariant.available;
    }

    if (addButtonText) {
      addButtonText.textContent = matchedVariant.available ? 'Add to Cart' : 'Sold Out';
    }
  };

  select(document, '[data-scrub-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-scrub-gallery-viewport]');
    const thumbs = select(gallery, '[data-scrub-gallery-thumb]');
    const slides = select(gallery, '.scrub-gallery__slide');
    const zoomDialog = gallery.querySelector('[data-scrub-zoom-dialog]');
    const zoomImage = gallery.querySelector('[data-scrub-zoom-image]');
    const setActiveSlide = (index) => {
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-current', String(thumbIndex === index)));
    };

    setActiveSlide(0);

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.scrubGalleryThumb || 0);
        const slide = viewport?.children[index];
        if (!slide) return;
        setActiveSlide(index);
        if (!window.matchMedia('(min-width: 750px)').matches) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
    });

    viewport?.addEventListener('scroll', () => {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      const index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
      setActiveSlide(index);
    }, { passive: true });

    select(gallery, '[data-scrub-zoom-src]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!window.matchMedia('(min-width: 750px)').matches || !zoomDialog || !zoomImage) return;
        zoomImage.src = button.dataset.scrubZoomSrc;
        zoomImage.alt = button.querySelector('img')?.alt || '';
        zoomDialog.showModal();
      });
    });

    zoomDialog?.addEventListener('click', (event) => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
  });

  select(document, '[data-scrub-option-group]').forEach((group) => {
    const selectedLabel = group.querySelector('[data-scrub-selected-label]');
    select(group, '[data-scrub-option]').forEach((button) => {
      button.addEventListener('click', () => {
        select(group, '[data-scrub-option]').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (selectedLabel) selectedLabel.textContent = button.dataset.scrubOption || button.textContent.trim();
        updateProductFormVariant();
      });
    });
  });

  updateProductFormVariant();

  select(document, '[data-scrub-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    const normalizeQuantity = () => {
      if (!input) return;
      const value = Number.parseInt(input.value, 10);
      input.value = String(Number.isFinite(value) && value > 0 ? value : 1);
    };

    select(quantity, 'button').forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.dataset.scrubQuantity === 'increase' ? 1 : -1;
        const currentValue = Number.parseInt(input?.value || '1', 10) || 1;
        const nextValue = Math.max(Number(input?.min || 1), currentValue + step);
        if (input) input.value = String(nextValue);
      });
    });

    input?.addEventListener('change', normalizeQuantity);
    input?.addEventListener('blur', normalizeQuantity);
  });

  select(document, '[data-scrub-accordions]').forEach((group) => {
    select(group, '[data-scrub-accordion-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-scrub-accordion]');
        const isOpen = item?.classList.contains('is-open');
        select(group, '[data-scrub-accordion]').forEach((accordion) => {
          accordion.classList.remove('is-open');
          accordion.querySelector('[data-scrub-accordion-button]')?.setAttribute('aria-expanded', 'false');
        });
        if (item && !isOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  select(document, '[data-scrub-modal-open]').forEach((button) => {
    button.addEventListener('click', () => {
      document.getElementById(button.dataset.scrubModalOpen)?.showModal();
    });
  });

  select(document, '[data-scrub-modal-close]').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('dialog')?.close();
    });
  });

  select(document, 'dialog[data-scrub-modal]').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  select(document, '[data-scrub-carousel]').forEach((carousel) => {
    const row = carousel.querySelector('[data-scrub-carousel-row]');
    select(carousel, '[data-scrub-carousel-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.scrubCarouselArrow === 'next' ? 1 : -1;
        row?.scrollBy({ left: direction * row.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  });

  select(document, '.scrub-order-now, .button, button[type="submit"]').forEach((button) => {
    button.addEventListener('pointerdown', () => {
      button.classList.remove('is-pressing');
      void button.offsetWidth;
      button.classList.add('is-pressing');
    });

    button.addEventListener('animationend', () => {
      button.classList.remove('is-pressing');
    });
  });

  const revealItems = select(document, '.medical-scrubs .scrub-product-info > *, .medical-scrubs .scrub-section__heading, .medical-scrubs .scrub-accordion, .medical-scrubs .scrub-related-card, .medical-scrubs .scrub-seen-card, .medical-scrubs .scrub-review-summary, .medical-scrubs .scrub-review-card, .medical-scrubs .scrub-email-signup');
  revealItems.forEach((item, index) => {
    item.classList.add('scrub-reveal');
    item.style.setProperty('--scrub-reveal-delay', `${Math.min(index % 6, 5) * 45}ms`);
  });

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
})();
